<template>
  <div>
    <v-row dense :key="order.id" class="mb-15">
      <template v-if="step == 1">
        <v-col cols="12" md="12">
          <PartnerItems
            :key="`support_items_${order.id}_${services.length}_${assets.length}`"
            :info="order"
            :services="services"
            :assets="assets"
            :summary="summary"
            ref="itemRef"
            @onUpdate="onUpdate"
          />
        </v-col>
        <v-col cols="12">
          <!-- :key="`support_delivery_${order.id}_${deliveryAddress.length}`" -->
          <SupportDelivery
            :info="order"
            :services="services"
            :accounts="accounts"
            :summary="summary"
            :delivery-address="deliveryAddress"
            ref="itemRef"
            @onUpdate="onUpdate"
          />
        </v-col>
      </template>
      <template v-else-if="step == 2">
        <v-col cols="12" md="12">
          <Payment
            :info="order"
            :summary="summary"
            :is-show-card-payment="false"
            ref="paymentRef"
            @onUpdate="onUpdate"
            @goBack="goBack"
          />
        </v-col>
      </template>
      <template v-else-if="step == 3">
        <v-col cols="12" md="12">
          <Success
            :info="order"
            :summary="summary"
            type="partner"
            ref="successRef"
            @onUpdate="onUpdate"
          />
        </v-col>
      </template>
    </v-row>
    <div class="fixed-bottom-block">
      <v-row dense>
        <template v-if="step == 1">
          <v-col cols="6">
            <v-btn color="error" small block @click="resetAll">
              {{ order.id ? $t("Hủy đơn") : $t("Làm lại") }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" small block @click="saveProcessing">
              {{ $t("Tiếp") }}
            </v-btn>
          </v-col>
        </template>
        <template v-else-if="step == 2">
          <v-col cols="6">
            <v-btn color="warning" small block @click="goBack">
              {{ $t("Quay lại") }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="primary" small block @click="paymentOnDelivery">
              {{ $t("Thanh toán sau") }}
            </v-btn>
          </v-col>
        </template>
        <template v-else-if="step == 3">
          <v-col cols="12">
            <v-btn
              color="purple"
              class="white--text"
              small
              block
              @click="pageReload"
            >
              {{ $t("Thêm yêu cầu mới") }}
            </v-btn>
          </v-col>
        </template>
      </v-row>
    </div>
  </div>
</template>

<script>
import { httpClient } from "@/libs/http";
import { httpNoLoading } from "@/libs/httpNoLoading";
import { debounce } from "lodash";
import { ORDER_STATUS } from "@/libs/const";
import moment from "moment";

export default {
  name: "Support",
  components: {
    PartnerItems: () => import("@/components/rent/PartnerItems"),
    Payment: () => import("@/components/rent/Payment"),
    Success: () => import("@/components/rent/Success"),
    SupportDelivery: () => import("@/components/rent/SupportDelivery"),
  },
  data: () => ({
    order: {
      id: "",
    },
    channels: [],
    countries: [],
    services: [],
    vouchers: [],
    assets: [],
    accounts: [],
    deliveryAddress: [],
    step: 1,
    me: {},
    isLoading: false,
    orderInterval: 0,
  }),
  computed: {
    selectedAccount() {
      if (!this.order.id_account_main) {
        return null;
      }
      return [...this.accounts].find(
        (acc) => acc.id == this.order.id_account_main
      );
    },
    selectedService() {
      if (
        !this.order.rent_day ||
        !this.order.id_asset ||
        !this.selectedAccount ||
        !this.selectedAccount.id
      ) {
        return [];
      }

      return [...this.services].find(
        (s) =>
          s.id_asset == this.order.id_asset &&
          (s.id_account == this.selectedAccount.id ||
            (s.id_city == this.selectedAccount.id_city &&
              s.id_account == -1)) &&
          s.from_day <= this.order.rent_day &&
          s.to_day >= this.order.rent_day
      );
    },
    summary() {
      const data = {
        total_price: 0,
        id_service: 0,
      };

      if (!this.selectedService) {
        return data;
      }

      const itemAmount = this.selectedService.price * this.order.rent_day;
      data.total_price = Math.round(itemAmount);
      data.id_service = this.selectedService.id;

      return data;
    },
  },
  mounted() {
    const { me } = window;
    this.me = { ...me };
    this.orderInterval = setInterval(() => {
      this.reCheckOrder();
    }, 5000);

    this.getAccounts();
    this.getProcessing();
    this.getAssets();
    this.getCountries();
    this.getChannels();
    this.getServices();
    this.listenSocket();
  },
  methods: {
    onAccountMainChanged() {
      this.getDeliveryAddress();
    },
    async reCheckOrder() {
      if (!this.order || !this.order.id || this.step != 2) {
        return false;
      }

      const { data } = await httpNoLoading.post("/order/v1/get-detail", {
        id_order: this.order.id,
      });

      if ([ORDER_STATUS.DEPOSIT, ORDER_STATUS.ON_GOING].includes(data.status)) {
        this.step = 3;
      }
    },

    async getDeliveryAddress() {
      if (!this.order.id_account_main) {
        this.deliveryAddress = [];
        return false;
      }

      const { data } = await httpClient.post(
        "/common/v1/get-delivery-address",
        {
          id_account_main: this.order.id_account_main,
        }
      );
      this.deliveryAddress = [...data];
    },
    async getProcessing() {
      const res = await httpClient.post("/order/v1/get-processing-support");
      if (res && res.data && res.data.id) {
        const { data } = await httpClient.post("/order/v1/get-detail", {
          id_order: res.data.id,
        });
        this.order = { ...data };
      }
    },
    async resetAll() {
      if (this.order.id) {
        const id_order = this.order.id;
        await httpClient.post("/order/v1/cancel-processing", {
          id_order,
        });
      }
      setTimeout(() => {
        this.pageReload();
      }, 500);
    },

    pageReload() {
      window.location.reload();
    },

    nextStep() {
      this.step++;
    },
    goBack() {
      this.step--;
    },

    onUpdate: debounce(function (order) {
      const isAccountChanged =
        this.order.id_account_main != order.id_account_main;
      this.order = { ...this.order, ...order };

      if (isAccountChanged) {
        this.onAccountMainChanged();
      }
    }, 200),

    async paymentOnDelivery() {
      if (!confirm("Xác nhận thanh toán khi giao xe")) {
        return false;
      }

      try {
        await httpClient.post("/order/v1/set-payment-on-delivery", {
          id: this.order.id,
        });
        this.step = 3;
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
      }
    },

    async saveProcessing() {
      if (!this.summary.id_service) {
        this.$vToastify.error(this.$t("Không có dịch vụ khả dụng"));
        return false;
      }

      let start_time = this.order.start_time;
      if (this.order.time_type == 1) {
        start_time = moment().format("YYYY-MM-DD HH:mm:ss");
      }
      if (!start_time) {
        this.$vToastify.error(this.$t("Chưa chọn thời gian nhận xe"));
        return false;
      }

      const delivery = [...this.deliveryAddress].find(
        (d) => d.id == this.order.id_account_delivery_address
      );
      if (!delivery) {
        this.$vToastify.error(this.$t("Chưa xác định địa điểm giao xe"));
        return false;
      }

      try {
        const { data } = await httpClient.post(
          "/order/v1/save-processing-support",
          {
            ...this.order,
            ...this.summary,
            start_time,
            phone: this.selectedAccount.phone,
            id_country: this.selectedAccount.id_country,
            delivery_id_city: (delivery && delivery.id_city) || null,
            delivery_id_county: (delivery && delivery.id_county) || null,
            delivery_id_ward: (delivery && delivery.id_ward) || null,
            delivery_address: (delivery && delivery.address) || null,
          }
        );
        this.order = { ...this.order, ...data };
        if (this.order.is_allow_debt) {
          this.step = 3;
        } else {
          this.nextStep();
        }
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
      }
    },

    listenSocket() {
      window.socket.on("order_paid", (data) => {
        console.log("listenSocket->data", data);

        const { id_order } = data;

        if (id_order == this.order.id && this.step == 2) {
          this.step = 3;
        }
      });
    },

    async getAccounts() {
      const { data } = await httpClient.post("/common/v1/get-contract-account");
      this.accounts = [...data];
    },

    async getCountries() {
      const { data } = await httpClient.post("/common/v1/get-country");
      this.countries = [...data];
    },

    async getChannels() {
      const { data } = await httpClient.post("/common/v1/get-channel", {
        type: 2,
      });
      this.channels = [...data];
    },

    async getAssets() {
      const { data } = await httpClient.post("/asset/v1/get-by-contract");
      this.assets = [...data];
    },

    async getServices() {
      const { data } = await httpClient.post("/common/v1/get-service");
      this.services = [...data];
    },
  },
};
</script>
